import React, { memo } from 'react'
import {
  faCheckCircle,
  faTimesCircle
} from '@fortawesome/pro-duotone-svg-icons'
import { useTranslation } from 'react-i18next'

import Popup from '../../shared/popup/Popup'
import { COLOR_ERROR, COLOR_SUCCESS } from '../../../constants/theme'

const EmailChangeConfirmation = ({ success, error, onSubmit }) => {
  const { t } = useTranslation()
  const params = success
    ? {
        title: t('message.email-address-changed'),
        description: t('message.email-address-changed-desc'),
        icon: faCheckCircle,
        color: COLOR_SUCCESS
      }
    : {
        title: t('message.failed-to-change-email'),
        description: t(error),
        icon: faTimesCircle,
        color: COLOR_ERROR
      }
  return (
    <Popup
      {...params}
      submitLabel={t('common.close')}
      onFormSubmit={onSubmit}
    />
  )
}

export default memo(EmailChangeConfirmation)
